import React from 'react';
import ReactDOM from 'react-dom';
import Mail from './components/mail/mail';
import './index.css';
import './font.css';

ReactDOM.render(<Mail />, document.getElementById('root'));
